import { PG_ERROR_CODE } from './Payments';

export const EVENT_API_URL = process.env.NEXT_PUBLIC_EVENT_FUNNEL_URL || '';

export const EVENT_TYPE = {
  SIGN_UP: 'SIGN_UP',
  WEB: 'WEB',
  SHOP: 'SHOP',
  FILTER: 'FILTER',
  VIDEO_CHAT: 'VIDEOCHAT',
  VIDEO_CHAT_DEBUG: 'VIDEOCHAT_DEBUG',
  PURCHASE: 'PURCHASE',
  VIP: 'VIP',
  PAYMENT: 'PAYMENT',
  BUTTON: 'BUTTON',
  GNB: 'GNB',
  UTM: 'UTM',
  EDIT_PROFILE: 'EDIT_PROFILE',
  EVENT_PAGE: 'EVENT_PAGE',
  HISTORY: 'HISTORY',
  VISITOR: 'VISITOR',
  DECO: 'DECO',
  VIEW: 'VIEW',
  MIRROR: 'MIRROR',
  BLOG: 'BLOG',
  WEB2APP: 'WEB2APP',
  DSAR: 'DSAR',
  POPUP: 'POPUP',
  ONBOARDING: 'ONBOARDING',
  /**
   * 계정/디바이스 블락 관련 이벤트
   */
  BLOCK: 'BLOCK',
  /**
   * 카메라, 마이크 등 리소스와 관련된 이벤트 로그
   */
  PERMISSION: 'PERMISSION',
  REPORT: 'REPORT', // 유저 신고/블록 등 모더레이션 이벤트
  LOG: 'LOG', // Data Analyst와 협의한 다목적 로그 이벤트
  DEBUG: 'DEBUG', // Data Analyst와 협의하지 않은 웹팀 자체적인 디버그 이벤트
  REDDOT: 'REDDOT',

  /**
   * 홍보성 요소와 관련된 이벤트 로그
   */
  PROMO: 'PROMO',

  /**
   * FaceTec 관련 이벤트 로그
   */
  FACETEC: 'FACETEC',

  /**
   * Yoti 관련 이벤트 로그
   */
  YOTI: 'YOTI',

  /**
   * 제재 관련 이벤트 로그
   */
  PUNISH: 'PUNISH',
  /**
   * 크리에이터 관련 이벤트 로그
   */
  CREATOR: 'CREATOR',
  /**
   * 인벤토리
   */
  INVENTORY: 'INVENTORY',
  /**
   * 팔로우 관련 이벤트 로그
   */
  FOLLOW: 'FOLLOW',
  /**
   * 푸시 알림
   */
  PUSH_NOTIFICATION: 'PUSH_NOTIFICATION',
  /**
   * 알림 센터 관련 이벤트 로그
   */
  NOTIFICATION_CENTER: 'NOTIFICATION_CENTER',
  PROMETHEUS: 'PROMETHEUS',
  /**
   * 구독 관련 이벤트 로그
   */
  SUBSCRIPTION: 'SUBSCRIPTION',
  /**
   * 인벤토리 관련 이벤트 로그
   */
  INVITE_FROM_SWIPE_AZAR: 'INVITE_FROM_SWIPE_AZAR',
} as const;

export const EVENT_NAME = {
  VIP_SYSTEM__IMPRESSION: 'vip_system__impression',
  VIP_SYSTEM__CLICK_PURCHASE: 'vip_system__click_purchase',
  VIP_SYSTEM__PURCHASE_DONE: 'vip_system__purchase_done',
  VIP_SYSTEM__CLICK_BUTTON: 'vip_system__click_button',
  POPUP_OPEN: 'popup_opened',
  SCREEN_OPEN__LOGIN: 'screen_opened__Login',
  SCREEN_OPEN__LOGIN_CHAT: 'screen_opened__Login_Chat',
  SCREEN_OPEN__LOGIN_METHOD: 'screen_opened__LoginMethod',
  SCREEN_OPEN__LOGIN_TERMS: 'screen_opened__Terms',
  SCREEN_OPEN__LOGIN_BIRTHDAY_INFO: 'screen_opened__BirthdayInfo',
  SCREEN_OPEN__LOGIN_GENDER_INFO: 'screen_opened__GenderInfo',
  SCREEN_OPEN__LOGIN_COMMUNITY: 'screen_opened__CommunityGuideline',
  SCREEN_OPEN__LOGIN_AGE_RESTRICTED: 'screen_opened__AgeRestricted',
  SCREEN_OPENED__PHONE_NUMBER: 'screenopened__VerifyPhoneNumber',
  SCREEN_OPENED__PHONE_VERIFICATION: 'screen_opened_SmsVerify',
  SCREEN_OPENED__EMAIL_INFO: 'screen_opened__EmailInfo',
  SCREEN_OPENED: 'screen_opened',
  LOGIN_SUCCESS: 'login_success',
  SCREEN_OPENED__MAIN_PAGE: 'screen_opened__Main_page',
  SIGNUP_COMPLETE: 'Signup_complete',
  // signup
  SIGN_UP_CLICK_RESEND: 'verify_click_RetryVerification',
  SIGNUP__SELECT_GENDER: 'signup__select_gender',
  SIGNUP__CLICK_HIDE_GENDER: 'signup__click_hide_gender',
  SIGNUP__IMPRESSION_NAME: 'signup__impression_name',
  SIGNUP__CLICK_NEXT_NAME: 'signup__click_next_name',
  SIGNUP__CLICK_SKIP_NAME: 'signup__click_skip_name',
  SIGNUP__IMPRESSION_MAIN_LANGUAGE: 'signup__impression_main_language',
  SIGNUP__CLICK_NEXT_MAIN_LANGUAGE: 'signup__click_next_main_language',
  SIGNUP__IMPRESSION_PREFERRED_LANGUAGE: 'signup__impression_preferred_language',
  SIGNUP__CLICK_NEXT_PREFERRED_LANGUAGE: 'signup__click_next_preferred_language',
  SIGNUP__IMPRESSION_ETHNICITY: 'signup__impression_ethnicity',
  SIGNUP__CLICK_NEXT_ETHNICITY: 'signup__click_next_ethnicity',
  SIGNUP__CLICK_SKIP_ETHNICITY: 'signup__click_skip_ethnicity',
  SIGNUP__CLICK_LEARN_MORE_ETHNICITY: 'signup__click_learn_more_ethnicity',
  SIGNUP__IMPRESSION_ETHNICITY_LEARN_MORE: 'signup__impression_ethnicity_learn_more',
  SIGNUP__CLICK_GOT_IT_ETHNICITY_LEARN_MORE: 'signup__click_got_it_ethnicity_learn_more',
  SIGNUP__IMPRESSION_PROFILEIMAGE: 'signup__impression_profileimage',
  SIGNUP__CLICK_SKIP_PROFILEIMAGE: 'signup__click_skip_profileimage',
  SIGNUP__CLICK_NEXT_PROFILEIMAGE: 'signup__click_next_profileimage',
  SIGNUP__IMPRESSION_SIGNUP_INTERESTS: 'signup__impression_signup_interests',
  SIGNUP_INTERESTS__CLICK_NEXT: 'signup_interests__click_next',
  SIGNUP_INTERESTS__CLICK_SKIP: 'signup_interests__click_skip',

  // 온보딩 - 초기 관심사 선택 모달
  INITIAL_INTERESTS__IMPRESSION_INTERESTS: 'initial_interests__impression_interests',
  INITIAL_INTERESTS__CLICK_APPLY: 'initial_interests__click_apply',
  INITIAL_INTERESTS__APPLY_INTEREST: 'initial_interests__apply_interest',

  // 미성년자 영구 블락
  ANYWHERE__REPORT_UNDERAGE_BLOCK: 'anywhere__report_underage_block',
  ANYWHERE__IMPRESSION_UNDERAGE_BLOCK: 'anywhere__impression_underage_block',
  ANYWHERE__CLICK_BLOCKED_CONTACT_US: 'anywhere__click_blocked_contact_us',

  // match blur
  BLUR__CONTINUE_MATCH: 'blur__continue_match',
  BLUR__REPORT_AND_LEAVE: 'blur__report_and_leave',
  MATCHING_ACTIVATE_BLUR: 'matching__activate_blur',

  // underage auto report
  MIRROR__IMPRESSION_CHILD_ALERT_TOAST: 'mirror__impression_child_alert_toast',
  MIRROR__IMPRESSION_CHILD_REPORTED_TOAST: 'mirror__impression_child_reported_toast',
  MIRROR__CLICK_CHILD_ALERT_BUTTON: 'mirror__click_child_alert_button',

  // after match popup
  MATCHING_AFTER_AUTOPOPUP_SHOW: 'matching_after_autopopup_show',
  MATCHING_AFTER_AUTOPOPUP_REPORT: 'matching_after_autopopup_report',
  MATCHING_AFTER_AUTOPOPUP_CANCEL: 'matching_after_autopopup_cancel',

  MIRROR__CLICK_VIDEO_CHAT_START: 'mirror__click_video_chat_start',
  ACCESS_REQUIRED_POPUP: 'accessrequired_popup_opened',
  SCREEN_OPENED__MATCH_FINDING: 'screen_opened__Match_finding',
  MATCH_FINDING__PROFILE: 'match_finding__profile',
  MATCH_RECEIVE__STOMP_MESSAGE: 'match_receive__stomp_message',
  MATCH_UUID: 'match_uuid',
  MATCHING__NEXT: 'matching__next',
  SHOP_OPEN: 'shop_open',
  PURCHASE_COMPLETE: 'purchase_complete',
  MATCHING__EXIT: 'matching__exit',
  DROP_IN_ERROR: 'drop_in_error',
  REDIRECT_DROP_IN_ERROR: '3d_secure_drop_in_error',
  FINDING__OPEN_GENDERFILTER: 'finding__open_genderfilter',
  FINDING__CLICK_GENDERFILTER: 'finding__click_genderfilter',
  FINDING__FILTER_BOTH: 'finding__filter_both',
  FINDING__FILTER_FEMALE: 'finding__filter_female',
  FINDING__FILTER_MALE: 'finding__filter_male',
  FINDING__FILTER_DEFAULT: 'finding__filter_default',
  FINDING__GENDERFILTER_GOMATCH: 'finding__genderfilter_gomatch',
  FINDING__GENDERFILTER_GOSHOP: 'finding__genderfilter_goshop',
  FINDING__GENDERFILTER_CLOSE: 'finding__genderfilter_close',
  MIRROR__OPEN_GENDERFILTER: 'mirror__open_genderfilter',
  MIRROR__CLICK_GENDERFILTER: 'mirror__click_genderfilter',
  MIRROR__FILTER_BOTH: 'mirror__filter_both',
  MIRROR__FILTER_FEMALE: 'mirror__filter_female',
  MIRROR__FILTER_MALE: 'mirror__filter_male',
  MIRROR__FILTER_DEFAULT: 'mirror__filter_default',
  MIRROR__GENDERFILTER_GOMATCH: 'mirror__genderfilter_gomatch',
  MIRROR__GENDERFILTER_GOSHOP: 'mirror__genderfilter_goshop',
  MIRROR__GENDERFILTER_CLOSE: 'mirror__genderfilter_close',
  MIRROR__CLICK_SHUFFLE: 'mirror__click_shuffle',
  MIRROR__OPEN_AGEFILTER: 'mirror__open_agefilter',
  MIRROR__CLICK_AGEFILTER: 'mirror__click_agefilter',
  MIRROR__OPEN_REGIONFILTER: 'mirror__open_regionfilter',
  MIRROR__CLICK_REGIONFILTER: 'mirror__click_regionfilter',
  MIRROR__OPEN_LANGUAGEFILTER: 'mirror__open_languagefilter',
  MIRROR__CLICK_LANGUAGEFILTER: 'mirror__click_languagefilter',
  MIRROR__CLICK_REGIONFILTER_SAVE: 'mirror__click_regionfilter_save',
  MIRROR__CLICK_AGEFILTER_SAVE: 'mirror__click_agefilter_save',
  MIRROR__CLICK_LANGUAGEFILTER_SAVE: 'mirror__click_languagefilter_save',
  MIRROR__CLICK_ADVANCED_FILTER: 'mirror__click_advanced_filter',
  MIRROR__IMPRESSION_UNIFORM_VIOLATION_POPUP: 'mirror__impression_uniform_violation_popup',

  MIRROR__CLICK_CAMERA_OFF: 'mirror__click_camera_off',

  MIRROR__CLICK_MATCH_FILTER_MODAL: 'mirror__click_match_filter_modal',
  MIRROR__CLICK_PREFER_LANGUAGE: 'mirror__click_prefer_language',
  MIRROR__CLICK_PREFER_LANGUAGE_MODAL: 'mirror__click_prefer_language_modal',
  MIRROR__REPORT_PREFER_LANGUAGE_INFO: 'mirror__report_prefer_language_info',
  MIRROR__CLICK_SHOP_IN_MATCH_FILTER: 'mirror__click_shop_in_match_filter',
  MIRROR__CLICK_SAVE_IN_MATCH_FILTER: 'mirror__click_save_in_match_filter',
  MIRROR__CLICK_START_IN_MATCH_FILTER: 'mirror__click_start_in_match_filter',
  MIRROR__CLICK_TAB_IN_MATCH_FILTER: 'mirror__click_tab_in_match_filter',
  MIRROR__IMPRESSION_FREE_MESSAGE_IN_MATCH: 'mirror__impression_free_message_in_match',
  MIRROR__CLICK_FREE_MESSAGE_IN_MATCH: 'mirror__click_free_message_in_match',

  FINDING__OPEN_LOCATIONFILTER: 'finding__open_locationfilter',
  FINDING__CLICK_LOCATIONFILTER: 'finding__click_locationfilter',
  FINDING__LOCATIONFILTER_GOMATCH: 'finding__locationfilter_gomatch',
  FINDING__LOCATIONFILTER_GOSHOP: 'finding__locationfilter_goshop',
  FINDING__LOCATIONFILTER_CLOSE: 'finding__locationfilter_close',
  MIRROR__OPEN_LOCATIONFILTER: 'mirror__open_locationfilter',
  MIRROR__CLICK_LOCATIONFILTER: 'mirror__click_locationfilter',
  MIRROR__LOCATIONFILTER_GOMATCH: 'mirror__locationfilter_gomatch',
  MIRROR__LOCATIONFILTER_GOSHOP: 'mirror__locationfilter_goshop',
  MIRROR__LOCATIONFILTER_CLOSE: 'mirror__locationfilter_close',
  MIRROR__CLICK_NEXT_VIDEO_CHAT: 'mirror__click_next_video_chat',
  MIRROR__CLICK_MATCH_END: 'mirror__click_match_end',

  CONSENT_POPUP__IMPRESSION: 'consent_popup__impression',
  VERIFY_CLICK_GET_VERIFICATION_CODE: 'verify_clickGetVerificationCode',
  CLICK_BUTTON: 'click_button',
  GNB__CLICK_MAIN: 'gnb__click_main',
  GNB__CLICK_TAB: 'gnb__click_tab',
  GNB__CLICK_SHOP: 'gnb__click_shop',
  GNB__CLICK_LOGIN: 'gnb__click_login',
  GNB__CLICK_PROFILE: 'gnb__click_profile',
  GNB__CLICK_ACCOUNT: 'gnb__click_account',
  GNB__CLICK_CREATOR_STUDIO: 'gnb__click_creator_studio',
  GNB__CLICK_CONTACTUS: 'gnb__click_contactus',
  GNB__CLICK_LOGOUT: 'gnb__click_logout',

  // 젬부족 모달
  GEM_LACK_POPUP__IMPRESSION: 'gem_lack_popup__impression',
  GEM_LACK_POPUP__ITEM_CLICK: 'gem_lack_popup__item_click',
  GEM_LACK_POPUP__CLICK_CLOSE: 'gem_lack_popup__click_close',
  ANYWHERE__REPORT_GEMLACK_INSPECTION: 'anywhere__report_gemlack_inspection',

  // 매치
  MIRROR__CLICK_CHAT_TOGGLE: 'mirror__click_chat_toggle',

  UTM_FIRST_OPEN: 'utm_first_open',
  EDIT_PROFILE_MODAL__CLICK_CLOSE: 'edit_profile_modal__click_close',
  EDIT_PROFILE_MODAL__IMPRESSION: 'edit_profile_modal__impression',
  EDIT_PROFILE_MODAL__CLICK_PREFER_LANGUAGE: 'edit_profile_modal__click_prefer_language',
  EDIT_PROFILE_MODAL__DONE: 'edit_profile_modal__done',
  FIRST_OPEN: 'first_open',
  FIRST_SESSION_OPEN: 'first_session_open',
  EVENT_PAGE_IMPRESSION: 'event_page__impression',
  EVENT_PAGE__IMPRESSION_EVENT_PAGE: 'event_page__impression_event_page',
  EVENT_PAGE_CLICK_BUTTON: 'event_page__click_button',
  OBS_REJECT_OPEN: 'obs_reject_open',
  OBS_REJECT_CLOSE: 'obs_reject_close',
  HISTORY_OPEN: 'HISTORY_OPEN',
  CHAT_CLICK: 'chat_click',
  HISTORY__CLICK_FOLLOW: 'history__click_follow',
  HISTORY_PROFILE_CARD_CLICK: 'history_profile_card_click',
  HISTORY_FILTER_CLICK: 'history_filter_click',
  HISTORY_OPTION_SELECT: 'history_option_select',

  VISITOR_CONFIG: 'visitor_config',
  LOAD_FAILED_DECO_MODEL: 'load_failed_deco_model',
  ANYWHERE__CLICK_EFFECT_ITEM: 'anywhere__click_effect_item',
  ANYWHERE__CLICK_EFFECT_RESET: 'anywhere__click_effect_reset',

  // 신고/차단
  BLOCK_USER: 'block_user',
  REPORT_BLOCK_CLICK: 'report_block_click',
  REPORT_BLOCK_REASON_POPUP_SELECT: 'report_block_reason_popup_select',
  REPORT_BLOCK_SELECT_POPUP_SELECT: 'report_block_select_popup_select',
  REPORT_USER: 'report_user',

  // DM 관련
  ANYWHERE__CLICK_MESSAGE: 'anywhere__click_message',
  ANYWHERE__CLICK_PROFILE_MESSAGE: 'anywhere__click_profile_message',
  MESSAGE__CLICK_GO_MEET_FRIEND: 'message__click_go_meet_friend',
  MESSAGE__OPEN_FOLLOW: 'message__open_follow',
  MESSAGE__CLICK_FOLLOW: 'message__click_follow',
  MESSAGE__OPEN_MESSAGE_SETTINGS: 'message__open_message_settings',
  MESSAGE__CLICK_LEAVE_MESSAGE_ROOM: 'message__click_leave_message_room',

  // Shop
  ANYWHERE__CLICK_SHOP_PRODUCT: 'anywhere__click_shop_product',
  SHOP__OPEN_SUB_INTRO: 'shop__open_sub_intro',
  SHOP__CLICK_SUB_START: 'shop__click_sub_start',
  SHOP__OPEN_SUB_PRODUCT_LIST: 'shop__open_sub_product_list',
  SHOP__CLICK_SUB_PRODUCT_CONTINUE: 'shop__click_sub_product_continue',

  // SETTINGS
  SETTINGS__CLICK_HIDE_GENDER: 'settings__click_hide_gender',

  AHAMOMENT_MATCH_10MIN: 'ahamoment__match_10min',
  AHAMOMENT_MATCH_20MIN: 'ahamoment__match_20min',
  AHAMOMENT_MATCH_30MIN: 'ahamoment__match_30min',

  // 여백모드
  MIRROR_CLICK_LETTERBOX: 'mirror__click_letterbox',
  MIRROR_CLICK_SPLIT: 'mirror__click_split',
  MATCH__RESULT_VIEWMODE: 'match__result_viewmode',

  // 데코 이펙트
  MIRROR_REPORT_FAIL_EFFECT: 'mirror__report_fail_effect',
  MIRROR_REPORT_NETWORK_FAIL_EFFECT: 'mirror__report_network_fail_effect',
  MIRROR_REPORT_EFFECT_AVAILABLE: 'mirror__report_effect_available',
  MIRROR__REPORT_GESTURE_TOGGLE: 'mirror__report_gesture_toggle',
  MIRROR__REPORT_OPERATE_GESTURE: 'mirror__report_operate_gesture',
  MIRROR__OPEN_GESTURE_EFFECT: 'mirror__open_gesture_modal', // 제스쳐 이펙트 모달 오픈
  ANYWHERE__OPEN_EFFECT_SCREEN: 'anywhere__open_effect_screen',

  //Blog
  BLOG__OPEN_TAB: 'blog__open_tab',
  BLOG__OPEN_CONTENT: 'blog__open_content',
  BLOG_CLICK_VIDEO_CHAT_START: 'blog__click_video_chat_start',

  // 앱 전환 플로우
  ANYWHERE__IMPRESSION_TO_APP_MODAL: 'anywhere__impression_to_app_modal',
  ANYWHERE__CLICK_TO_APP_BTN: 'anywhere__click_to_app_btn',

  // DSAR
  ANYWHERE__IMPRESSION_DATA_REQUEST_FORM: 'anywhere__impression_data_request_form',
  ANYWHERE__SUBMIT_DATA_REQUEST_FORM: 'anywhere__submit_data_request_form',

  // 회원가입 A/B 테스트
  SIGNUP__IMPRESSION_BIRTHDAY_INFO_RETRY_POPUP: 'signup__impression_birthday_info_retry_popup',
  SIGNUP__CLICK_BIRTHDAY_INFO_RETRY_BUTTON: 'signup__click_birthday_info_retry_button',
  SIGNUP__IMPRESSION_FEATURE_CONSENT_POPUP: 'signup__impression_feature_consent_popup',
  SIGNUP__CLICK_FEATURE_CONSENT_POPUP: 'signup__click_feature_consent_popup',

  // 스타터패키지
  STARTER_PACKAGE_POPUP_V1_IMPRESSION: 'starterpackage_popup_v1_impression',
  STARTER_PACKAGE_POPUP_V1_CLICK_BUTTON: 'starterpackage_popup_v1_click_button',
  STARTER_PACKAGE_POPUP_V1_CLOSE: 'starterpackage_popup_v1_close',
  ANYWHERE_IMPRESSION_BOUNCE_POPUP: 'anywhere__impression_bounce_popup',
  ANYWHERE_CLICK_BOUNCE_POPUP_BUTTON: 'anywhere__click_bounce_popup_button',
  ANYWHERE_IMPRESSION_CONSENT_POPUP: 'anywhere__impression_consent_popup',
  ANYWHERE_CLICK_CONSENT_BUTTON: 'anywhere__click_consent_button',
  ANYWHERE_CLICK_LINK_BUTTON: 'anywhere__click_link_button',

  // 임시 비디오 채팅 디버그
  DEBUG__MATCH_LOGGING: 'debug__match_logging',
  DEBUG__WEB_PERFORMANCE_SUMMARY: 'debug__web_performance_summary',

  // 디버그 로그
  GENERAL_CONNECTION_FAIL: 'generalConnection_fail',
  NETWORK_HTTP_REQUESTS: 'network_http_requests',
  BROKER_ON_CONNECT: 'broker_on_connect',
  BROKER_ON_SUBSCRIBE_RESULT: 'broker_on_subscribe_result',

  // 매치 불가 로그
  ANYWHERE__REPORT_MATCH_REJECTED: 'anywhere__report_match_rejected',

  // Liquidity Sharing 동의 팝업
  MIRROR__IMPRESSION_LIQUIDITY_POPUP: 'mirror__impression_liquidity_popup',
  MIRROR__CLICK_LIQUIDITY_POPUP: 'mirror__click_liquidity_popup',

  // 온보딩 - 얼굴 인증
  ONBOARDING__IMPRESSION_FACE_CHECK: 'onboarding__impression_face_check',
  ONBOARDING__CLICK_START_VERIFICATION: 'onboarding__click_start_verification',
  ONBOARDING__IMPRESSION_FACE_VERIFYING: 'onboarding__impression_face_verifying',
  ONBOARDING__IMPRESSION_FACE_VERIFIED: 'onboarding__impression_face_verified',
  ONBOARDING__IMPRESSION_FACE_VERIFY_FAIL: 'onboarding__impression_face_verify_fail',
  ONBOARDING__CLICK_FACE_VERIFY_CONTACT: 'onboarding__click_face_verify_contact',
  ONBOARDING__IMPRESSION_FACE_VERIFY_ERROR: 'onboarding__impression_face_verify_error',
  ONBOARDING__CLICK_FACE_VERIFY_RETRY: 'onboarding__click_face_verify_retry',
  ONBOARDING__IMPRESSION_FACE_VERIFY_INFO: 'onboarding__impression_face_verify_info',
  ONBOARDING__CLICK_FACE_VERIFY_INFO_DONE: 'onboarding__click_face_verify_info_done',

  // 미디어 리소스
  ANYWHERE__REPORT_PERMISSION_STATUS: 'anywhere__report_permission_status',

  // 레드닷 뱃지
  ANYWHERE__IMPRESSION_RED_DOT: 'anywhere__impression_red_dot',
  ANYWHERE__CLICK_RED_DOT: 'anywhere__click_red_dot',

  // 히스토리 배너
  HISTORY__IMPRESSION_BANNER: 'history__impression_banner',
  HISTORY__CLICK_BANNER: 'history__click_banner',

  // 홍보성 요소 관련
  ANYWHERE__IMPRESSION_PROMO_BANNER: 'anywhere__impression_promo_banner',
  ANYWHERE__CLICK_PROMO_BANNER: 'anywhere__click_promo_banner',

  // 크리에이터 모집
  ANYWHERE__CLICK_CREATOR_PROGRAM: 'anywhere__click_creator_program',
  CREATOR__CLICK_CREATOR_APPLY: 'creator__click_creator_apply',
  CREATOR__CLICK_CREATOR_REWARD: 'creator__click_creator_reward',
  ANYWHERE__CLICK_CERTIFICATION_METHOD: 'anywhere__click_certification_method',
  ANYWHERE__IMPRESSION_CERTIFICATION: 'anywhere__impression_certification',
  CREATOR__CLICK_CREATOR_TAB: 'creator__click_creator_tab',
  ANYWHERE__CLICK_CREATOR_VIEWMODE_BUTTON: 'anywhere__click_creator_viewmode_button',

  // 치로 앱 다운로드 유도용 팝업
  LOGIN__IMPRESSION_CHEERO_REDIRECT_POPUP: 'login__impression_cheero_redirect_popup',
  LOGIN__CLICK_CHEERO_REDIRECT_POPUP: 'login__click_cheero_redirect_popup',

  // 아이템 부족 모달
  ITEM_LACK_POPUP__IMPRESSION: 'item_lack_popup__impression',
  ITEM_LACK_POPUP__CLICK_PURCHASE: 'item_lack_popup__click_purchase',
  ITEM_LACK_POPUP__CLICK_CLOSE: 'item_lack_popup__click_close',

  // Liveness & age check
  ANYWHERE__IMPRESSION_LIVENESS_VERIFY_INFO: 'anywhere__impression_liveness_verify_info',
  ANYWHERE__CLICK_START_LIVENESS_VERIFY_INFO: 'anywhere__click_start_liveness_verify_info',
  ANYWHERE__IMPRESSION_LIVENESS_CHECK: 'anywhere__impression_liveness_check',
  ANYWHERE__IMPRESSION_LIVENESS_VERIFY_REVIEW: 'anywhere__impression_liveness_verify_review',
  ANYWHERE__IMPRESSION_MPAAS_AGE_VERIFY_FAIL: 'anywhere__impression_mpaas_age_verify_fail',
  ANYWHERE__CLICK_MPAAS_AGE_VERIFY_CONTACT: 'anywhere__click_mpaas_age_verify_contact',
  ANYWHERE__IMPRESSION_LIVENESS_VERIFY_ERROR: 'anywhere__impression_liveness_verify_error',
  ANYWHERE__CLICK_LIVENESS_VERIFY_RETRY: 'anywhere__click_liveness_verify_retry',
  ANYWHERE__IMPRESSION_LIVENESS_ACCOUNT_POPUP: 'anywhere__impression_liveness_account_popup',
  ANYWHERE__CLICK_LIVENESS_ACCOUNT_POPUP_BUTTON: 'anywhere__click_liveness_account_popup_button',
  ANYWHERE__CLICK_LIVENESS_PUSH_PERM_BUTTON: 'anywhere__click_liveness_push_perm_button',
  ANYWHERE__CLICK_LIVENESS_VERIFY_CLOSE: 'anywhere__click_liveness_verify_close',
  ANYWHERE__CLICK_LIVENESS_VERIFY_CONTACT_US: 'anywhere__click_liveness_verify_contact_us',
  ANYWHERE__CLICK_LIVENESS_VERIFY_WEB_TO_APP: 'anywhere__click_liveness_verify_web_to_app',
  ANYWHERE__IMPRESSION_LIVENESS_CHECK_CAPTURE_BUTTON:
    'anywhere__impression_liveness_check_capture_button',
  ANYWHERE__REPORT_LIVENESS_SUBMIT_ATTEMPT: 'anywhere__report_liveness_submit_attempt',
  ANYWHERE__REPORT_LIVENESS_SUBMIT_RESULT: 'anywhere__report_liveness_submit_result',
  ANYWHERE__CLICK_LIVENESS_CHECK_CAPTURE_BUTTON: 'anywhere__click_liveness_check_capture_button',
  ANYWHERE__REPORT_LIVENESS_ERROR: 'anywhere__report_liveness_error',
  ANYWHERE__REPORT_LIVENESS_CHECK_READY: 'anywhere__report_liveness_check_ready',
  ANYWHERE__IMPRESSION_LIVENESS_NOTIFICATION_ON_BUTTON:
    'anywhere__impression_liveness_notification_on_button',

  // 브라우저 이탈 디버그 이벤트 (SCREEN_OPENED 대응)
  DEBUG__SESSION_END: 'debug__session_end',

  // Yoti 인증 퍼널 이탈 디버그 이벤트
  DEBUG__YOTI_FUNNEL_EXIT: 'debug__yoti_funnel_exit',
  // Yoti onReadyForCapture까지 걸린 시간 디버그 이벤트
  DEBUG__YOTI_READY_FOR_CAPTURE: 'debug__yoti_ready_for_capture',
  // Yoti 에러 에러코드 디버그 이벤트
  DEBUG__YOTI_SDK_ERROR: 'debug__yoti_sdk_error',
  // Yoti 카메라 접근 디버그 이벤트
  DEBUG__YOTI_CAMERA_ACCESS_REQUESTED: 'debug__yoti_camera_access_requested',
  DEBUG__YOTI_CAMERA_ACCESS_GRANTED: 'debug__yoti_camera_access_granted',
  DEBUG__YOTI_CAMERA_ACCESS_FAILED: 'debug__yoti_camera_access_failed',

  // FaceTec debug
  DEBUG__FACETEC_INIT_FAILURE: 'debug__facetec_init_failure',
  DEBUG__FACETEC_SESSION_DISMISSED: 'debug__facetec_session_dismissed',
  // FaceTec 카메라 접근 디버그 이벤트
  DEBUG__FACETEC_CAMERA_ACCESS_REQUESTED: 'debug__facetec_camera_access_requested',
  DEBUG__FACETEC_CAMERA_ACCESS_GRANTED: 'debug__facetec_camera_access_granted',
  DEBUG__FACETEC_CAMERA_ACCESS_FAILED: 'debug__facetec_camera_access_failed',

  // 제재
  LOGIN__IMPRESSION_PUNISH_POPUP: 'login__impression_punish_popup',
  LOGIN__CLICK_PUNISH_POPUP_BUTTON: 'login__click_punish_popup_button',

  MANAGE_ACCOUNT__IMPRESSION_DELETE_ACCOUNT_POPUP:
    'manage_account__impression_delete_account_popup',
  DELETE_ACCOUNT_POPUP__CLICK_CANCEL_BUTTON: 'delete_account_popup__click_cancel_button',
  DELETE_ACCOUNT_POPUP__CLICK_DELETE_ACCOUNT_BUTTON:
    'delete_account_popup__click_delete_account_button',
  LOGIN__IMPRESSION_DELETE_ACCOUNT_SCHEDULED_POPUP:
    'login__impression_delete_account_scheduled_popup',
  DELETE_ACCOUNT_SCHEDULED_POPUP__CLICK_KEEP_DELETION_BUTTON:
    'delete_account_scheduled_popup__click_keep_deletion_button',
  DELETE_ACCOUNT_SCHEDULED_POPUP__CLICK_CREATE_NEW_ACCOUNT_BUTTON:
    'delete_account_scheduled_popup__click_create_new_account_button',
  DELETE_ACCOUNT_SCHEDULED_POPUP__CLICK_RESTORE_ACCOUNT_BUTTON:
    'delete_account_scheduled_popup__click_restore_account_button',

  // 인벤토리
  ANYWHERE__CLICK_INVENTORY: 'anywhere__click_inventory',
  ANYWHERE__IMPRESSION_INVENTORY: 'anywhere__impression_inventory',

  // 프로필
  ANYWHERE__CLICK_PROFILE_FOLLOW: 'anywhere__click_profile_follow',
  ANYWHERE__CLICK_PROFILE_FAVORITE: 'anywhere__click_profile_favorite',
  ANYWHERE__CLICK_OTHER_PROFILE: 'anywhere__click_other_profile',
  PROFILE__IMPRESSION_AZAR_BADGE_MODAL: 'profile__impression_azar_badge_modal',
  PROFILE__CLICK_AZAR_BADGE: 'profile__click_azar_badge',
  MY_PROFILE__IMPRESSION_AZAR_BADGE_MODAL: 'my_profile__impression_azar_badge_modal',
  MY_PROFILE__CLICK_AZAR_BADGE: 'my_profile__click_azar_badge',

  // 프로필 수정 영역의 preferred_language 영역 클릭
  EDIT_PROFILE__CLICK_PREFERRED_LANGUAGE: 'edit_profile__click_preferred_language',
  ANYWHERE__CLICK_APPLY_PREFERRED_LANGUAGE: 'anywhere__click_apply_preferred_language',

  // PWA
  ANYWHERE__CLICK_PWA_BANNER: 'anywhere__click_pwa_banner',
  ANYWHERE__IMPRESSION_PWA_BANNER: 'anywhere__impression_pwa_banner',
  PWA_GUIDE__IMPRESSION_PWA_GUIDE: 'pwa_guide__impression_pwa_guide',

  // 알림 센터
  NOTIFICATION__CLICK_NOTIFICATION: 'notification__click_notification',
  NOTIFICATION__IMPRESSION: 'notification__impression',
  NOTIFICATION__NOTIFICATION_IMPRESSION: 'notification__notification_impression',

  // 매치 필터
  SUPER_MATCH__CLICK_TOGGLE: 'super_match__click_toggle',
  MIRROR__CLICK_AGE_FILTER: 'mirror__click_age_filter',
  MIRROR__CLICK_MATCH_FILTER_GUIDE_BUTTON: 'mirror__click_match_filter_guide_button',
  MIRROR__CLICK_CAMERA_ON_FILTER_TOGGLE: 'mirror__click_camera_on_filter_toggle',
  MIRROR__CLICK_AGE_FILTER_SAVE_BUTTON: 'mirror__click_age_filter_save_button',

  // 푸시 알림
  ANYWHERE__CLICK_PUSH_PERMISSION_POPUP_BUTTON: 'anywhere__click_push_permission_popup_button',
  ANYWHERE__IMPRESSION_PUSH_PERMISSION_POPUP: 'anywhere__impression_push_permission_popup',
  ANYWHERE__CLICK_PUSH_MESSAGE: 'anywhere__click_push_message',
  ANYWHERE__CLICK_NOTIFICATION_TOGGLE: 'anywhere__click_notification_toggle',

  // Assistant Consent
  ANYWHERE__IMPRESSION_ASSISTANT_CONSENT_POPUP: 'anywhere__impression_assistant_consent_popup',
  ASSISTANT_CONSENT_POPUP__CLICK_AGREE: 'assistant_consent_popup__click_agree',
  ASSISTANT_CONSENT_POPUP__CLICK_LEARN_MORE: 'assistant_consent_popup__click_learn_more',
  ASSISTANT_CONSENT_POPUP__IMPRESSION_MISS_OUT_POPUP:
    'assistant_consent_popup__impression_miss_out_popup',
  ASSISTANT_CONSENT_POPUP__CLICK_LEAVE_NOW: 'assistant_consent_popup__click_leave_now',

  // STT Consent
  ANYWHERE__IMPRESSION_STT_CONSENT_POPUP: 'anywhere__impression_stt_consent_popup',
  STT_CONSENT_POPUP__CLICK_AGREE: 'stt_consent_popup__click_agree',

  // STT Settings (Safari denied guide)
  ANYWHERE__IMPRESSION_STT_SETTINGS_POPUP: 'anywhere__impression_stt_settings_popup',
  STT_SETTINGS_POPUP__CLICK_DONE: 'stt_settings_popup__click_done',
  STT_SETTINGS_POPUP__CLICK_OPEN_SETTINGS: 'stt_settings_popup__click_open_settings',

  // Settings - Assistant
  SETTINGS__CLICK_ASSISTANT: 'settings__click_assistant',
  ASSISTANT__CLICK_ACTIVATE_TOGGLE: 'assistant__click_activate_toggle',
  ASSISTANT__CLICK_WITHDRAW: 'assistant__click_withdraw',
  ASSISTANT__CLICK_DISABLE: 'assistant__click_disable',
  ASSISTANT__CLICK_STT_ACTIVATE_TOGGLE: 'assistant__click_stt_activate_toggle',
  ASSISTANT__CLICK_STT_DEACTIVATE_TOGGLE: 'assistant__click_stt_deactivate_toggle',

  // Match status checks
  MIRROR__CHECK_ASSISTANT_CONSENTED: 'mirror__check_assistant_consented',
  MIRROR__CHECK_ASSISTANT_ENABLED: 'mirror__check_assistant_enabled',
  MIRROR__CHECK_STT_STATUS: 'mirror__check_stt_status',
  MIRROR__CHECK_STT_SUBTITLES_ENABLED: 'mirror__check_stt_subtitles_enabled',

  // STT recognition
  MIRROR__ATTEMPT_STT: 'mirror__attempt_stt',
  MIRROR__SUCCEED_STT: 'mirror__succeed_stt',
  MIRROR__FAIL_STT: 'mirror__fail_stt',
  MIRROR__COUNT_SUCCEED_STT: 'mirror__count_succeed_stt',

  // Account - Conversation Data
  MANAGE_ACCOUNT__CLICK_DELETE_MY_CONVERSATION_DATA:
    'manage_account__click_delete_my_conversation_data',
  DELETE_MY_CONVERSATION_DATA__CLICK_DELETE: 'delete_my_conversation_data__click_delete',

  // STT Consent - Leave
  STT_CONSENT_POPUP__IMPRESSION_MISS_OUT_POPUP: 'stt_consent_popup__impression_miss_out_popup',
  STT_CONSENT_POPUP__CLICK_LEAVE_NOW: 'stt_consent_popup__click_leave_now',

  // Device STT status report
  ANYWHERE__REPORT_DEVICE_STT_STATUS: 'anywhere__report_device_stt_status',

  // subscription
  SUBS__IMPRESSION: 'subs__impression',
  SUBS__CHANGE_TAB: 'subs__change_tab',
  SUBS__CLICK_BUTTON: 'subs__click_button',
  SUBS__CLICK_DETAIL_GUIDE: 'subs__click_detail_guide',
  SUBS_PLAN__IMPRESSION: 'subs_plan__impression',
  SUBS_PLAN__CLICK_BUTTON: 'subs_plan__click_button',
  SUBS__PURCHASE_DONE: 'subs__purchase_done',
  MIRROR__CLICK_MATCH_FILTER_SUBS_BANNER: 'mirror__click_match_filter_subs_banner',
  MIRROR__IMPRESSION_MATCH_FILTER_SUBS_BANNER: 'mirror__impression_match_filter_subs_banner',

  // invite from swipe azar
  SWIPE_INVITE__IMPRESSION_INVITE: 'swipe_invite__impression_invite',
  SWIPE_INVITE__CLICK_SKIP: 'swipe_invite__click_skip',
  SWIPE_INVITE__CLICK_CONTINUE_WITH_ALL_USERS: 'swipe_invite__click_continue_with_all_users',
  SWIPE_INVITE__CLICK_CONTINUE_WITH_SELECTED_USERS:
    'swipe_invite__click_continue_with_selected_users',
  SWIPE_INVITE__CLICK_DELETE: 'swipe_invite__click_delete',
} as const;

export const ERROR_STATUS = {
  USER_OUT: 'USER_OUT',
  FAIL: 'FAIL',
} as const;

export const getErrorStatus = (code: string) =>
  code === PG_ERROR_CODE.PAY_PROCESS_CANCELED || code === 'Cancelled'
    ? ERROR_STATUS.USER_OUT
    : ERROR_STATUS.FAIL;

export type EventType = (typeof EVENT_TYPE)[keyof typeof EVENT_TYPE];
export type EventName = (typeof EVENT_NAME)[keyof typeof EVENT_NAME];
export type EventOption = {
  [key: string]: string | Record<string, string | string[] | undefined>;
};

export const EVENT_LOGIN_MODAL_VISITOR_TRIGGER = {
  GENDER_BUTTON: 'gender_button',
  LOCATION_BUTTON: 'location_button',
  MATCH_START_BUTTON_MIRROR: 'match_start_button_mirror',
  MATCH_START_BUTTON_HISTORY: 'match_start_button_history',
  OBJECT_FIT_BUTTON: 'object_fit_button',
  DECO_FILTER_BUTTON: 'effect_icon_button',
  GESTURE_EFFECT_ICON_BUTTON: 'gesture_effect_icon_button',
  HEADER_SHOP: 'header_shop',
  LOGIN_BUTTON: 'login_button',
  RENEW_ACCESS_TOKEN: 'renewaccesstoken',
  BOUNCE_POPUP: 'bounce_popup',
  SEO_AZAR_LOGO: 'seo_azar_logo',
  SEO_START_VIDEO_CHAT: 'seo_start_video_chat',
  LIVENESS_SWITCH_ACCOUNT: 'liveness_switch_account',
  ABOUT_CTA_BUTTON: 'about_cta_button',
} as const;

export type EventLoginModalVisitorTrigger =
  (typeof EVENT_LOGIN_MODAL_VISITOR_TRIGGER)[keyof typeof EVENT_LOGIN_MODAL_VISITOR_TRIGGER];

export const EVENT_DEV_API_URL = process.env.NEXT_PUBLIC_EVENT_GATEWAY_DEV_URL || '';
